// import Sprite from "../object-graphics/Sprite";
import { CELL_SIZE } from "../../helpers/consts";
import styles from "./MapCell.module.css";

export default function MapCell({ x, y, frameCoord, onClick, isEditable }) {
  return (
    <div
      onClick={() => {
        if (isEditable) {
          onClick();
        }
      }}
      className={`${styles.cell} ${isEditable ? styles.editable : ""}`}
      style={{
        left: x * CELL_SIZE,
        top: y * CELL_SIZE,
      }}
    >
      {/*<Sprite frameCoord={frameCoord} />*/}
    </div>
  );
}
